import { jsx as _jsx } from "react/jsx-runtime";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { observer } from "mobx-react";
import React from "react";
import { useHeaderSignUpCopy } from "@faire/retailer/components/Header/__internal__/useHeaderSignUpCopy";
import { HeaderButton } from "@faire/retailer/components/Header/styled";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useNavigateAndHideMenu } from "./Navigation/useNavigateAndHideMenu";
var HeaderMobileSignUpBase = function() {
    var isSSR = useIsSSR();
    var retailer = useRetailerStore([
        "retailer"
    ]).retailer;
    var navigateToSignUp = useNavigateAndHideMenu().navigateToSignUp;
    var signUpCopy = useHeaderSignUpCopy();
    if (retailer === undefined) {
        return /*#__PURE__*/ _jsx(HeaderButton, {
            onClick: function() {
                return navigateToSignUp(undefined, {
                    sourceId: "mobile_side_catnav_signup_cta"
                });
            },
            // We set a link for graceful degredation in SSR.
            linkTo: isSSR ? getCurrentPath().replace({
                signUp: "1"
            }).toString() : undefined,
            "data-test-id": "signUpButton",
            children: signUpCopy
        });
    }
    return null;
};
export var HeaderMobileSignUp = observer(HeaderMobileSignUpBase);
